<template>
    <div class="json chartConfig_viewDP">
        <div class="chartDivConfig inpViewConfig for_dl" v-for="(item,index) in config.wd" :key="index">
            <span class="span_til">维度{{index+1}}</span>
            <el-input v-model="config.wd[index]"></el-input>
        </div>
        <div class="chartDivConfig inpViewConfig for_dl" v-for="(item,index) in config.dl">
            <span class="span_til">度量{{index+1}}</span>
            <el-input v-model="config.dl[index]"></el-input>
            <FSvg title="删除" :color="'#bf6a4e'" IconSize="18" @click.native="getDl('del',index)"></FSvg>
        </div>
        <FSvg title="加" :color="'#41ac46'" IconSize="16" @click.native="getDl('add')"></FSvg>
    </div>
</template>

<script>

    /**
     @author xiaoye
     @date 2020/5/12 2:40 下午
     */
    export default {
        name: 'json',
        components: {},
        props: {},
        data() {
            return {}
        },
        computed: {
            config() {
                return this.$store.state.designer.updParam.JSONData.params;
            },
        },
        methods: {
            getDl(type, index) {
                if (type === 'del') {
                    this.config.dl.splice(index, 1)
                } else if (type === 'add') {
                    this.config.dl.push('')
                }
            }
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .json {
        .inpViewConfig {
            white-space: nowrap;

            .span_til {
                max-width: 50px;
                width: 15%;
                letter-spacing: 2px;
            }

            .el-input {
                width: 70%;
            }
        }

        .for_dl {
            .FSvg {
                margin-left: 3%;
            }
        }
    }
</style>